import React, { ReactNode } from 'react';
import { StyledNavLink } from './LinkStyles';

export type TLinkPath = string;

export interface ILinkProps {
  path: TLinkPath;
  children: ReactNode;
}

const Link = ({ path, children }: ILinkProps): JSX.Element => <StyledNavLink to={path}>{children}</StyledNavLink>;

export default Link;
